export const formatAsCurrency = intValue => {
  if (intValue > 0) {
    return intValue.toLocaleString({
      style: 'currency',
      currency: 'GBP',
      currencyDisplay: 'symbol',
      minimumSignificantDigits: 0,
      maximumSignificantDigits: 0
    });
  }
  return intValue;
};

export const parseCurrencyString = value =>
  typeof value === 'string' ? parseFloat(value.replace(/[^\d.]/g, '')) : value;
